
export const APP_VERSION = '1.0.5';
export const APP_VERSION_DEV = '1.0.2';
export const BUILD_DATE = '17-06-2026 10:51:11';
export const BUILD_NUMBER = '170620261051';
